<p-dialog [draggable]="false" [header]="'Update ' + tableService.editColumn?.column?.name" [(visible)]="visible"  [style]="{width: '30vw'}">
  <div class="datagrid-form">
    <div class="datagrid__fields">
      @if (tableService.editColumn.column) {
        <div class="form-field-box">
          <label for="title-input">{{ tableService.editColumn?.column?.name }}</label>
          <input type="text" [(ngModel)]="tableService.editColumn.column.name" id="title-input" name="title" placeholder="Chad">
        </div>
      }
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="close.emit('close')" type="button" class="btn-bg"  data-dismiss="modal">Cancel</button>
    <button type="button" class="btn-bg">Update</button>
  </ng-template>
</p-dialog>

<!-- <div id="exampleModalCenter" class="modal fade show" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" style="display: block;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">Update {{ tableService.editColumn?.column?.name }}</h5>
        <button (click)="close.emit('close')" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="datagrid-form">
          <div class="datagrid__fields">
            <div class="form-field-box">
              <label for="title-input">{{ tableService.editColumn?.column?.name }}</label>
              <input type="text" id="title-input" name="title" placeholder="Chad">
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button (click)="close.emit('close')" type="button" class="btn btn-secondary"
          data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary">Update</button>
      </div>
    </div>
  </div>
</div> -->